var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"display-flex flex-row flex-1 tab-button flex-align-center",class:{
		disabled: _vm.isTabDisabled,
		'left-button': _vm.tabIndex === 0,
		'right-button': _vm.tabIndex === 1,
		'only-button': _vm.panels.length === 1,
		active: _vm.openedPanelIndex === _vm.tabIndex,
	},on:{"click":_vm.onClick}},[_c('div',{staticClass:"display-flex flex-column width-100"},[_c('div',{staticClass:"tab-title"},[_vm._v(_vm._s(`${_vm.tabIndex + 1}. ${_vm.panel.title}`))]),_c('div',{staticClass:"tab-description display-flex flex-row flex-align-center"},[_vm._v(" "+_vm._s(_vm.panel.description)+" "),_c('AppTooltip',{attrs:{"position":"bottom","text":_vm.panel.tooltipDescription}},[_c('SIcon',{staticClass:"info-icon ml-1",attrs:{"name":"installation-tab-info","width":"12","height":"12"}})],1)],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }